module.exports = "//img1.rrcimg.com/_next/static/src/assets/loading-small_30q9v.jpg";